import script from "./summary-event-rule-form.vue?vue&type=script&setup=true&lang=js"
export * from "./summary-event-rule-form.vue?vue&type=script&setup=true&lang=js"

import "./summary-event-rule-form.vue?vue&type=style&index=0&id=8c2c2440&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c2c2440"]])

export default __exports__